import { FormattedMessage } from 'react-intl';
import ErrorState from '@rio-cloud/rio-uikit/ErrorState';

type InternalServerErrorStateProps = {
    reloadTriggerFunction?: () => void;
    className?: string;
    fullWidth?: boolean;
};

const InternalServerErrorState = ({ reloadTriggerFunction, className, fullWidth }: InternalServerErrorStateProps) => (
    <ErrorState
        headline={<FormattedMessage id="intl-msg:fleetstatus.utils.error.emptyState.headline" />}
        message={<FormattedMessage id="intl-msg:fleetstatus.utils.error.emptyState.message" />}
        buttons={[
            {
                text: <FormattedMessage id="intl-msg:fleetstatus.utils.error.emptyState.button" />,
                onClick: reloadTriggerFunction,
            },
        ]}
        innerClassName={className}
        fullWidth={fullWidth}
    />
);

export default InternalServerErrorState;
